import { onMounted, computed, ref } from 'vue'
import qs from '@halobear/utils/qs'
import { useRoute } from 'vue-router'

import * as Api from '@/api/travel'

export default () => {
  const data = ref([])
  const route = useRoute()

  const fetchData = async () => {
    const hotel_id = route.query.hotel_id || qs.get('hotel_id')
    const phone = route.query.phone || qs.get('phone')
    const { list = [] } = await Api.serviceList({ hotel_id, is_merchant: phone ? 1 : 0 })
    data.value = list
  }

  const packages = computed(() => {
    const hall_id = route.query.hall_id || qs.get('hall_id')
    return data.value.filter((item) => item.hall_id == hall_id)
  })

  onMounted(fetchData)

  return {
    fetchData,
    data,
    packages,
  }
}
